import React, { useState, useEffect } from 'react';

import SatQuestionArea from '@components/common/satUI/SatQuestionArea';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatSelect from '@components/common/satUI/SatSelect';
import SatInput from '@components/common/satUI/SatInput';
import SatButton from '@components/common/satUI/SatButton';
import { isEmptyString } from '@common/utils';

const HobbyInfo = props => {
  const { category3, onChange, onNext, isDisabled, setIsDisabled } = props;

  const [errorCheckSubData, setErrorCheckSubData] = useState(false); // 세부항목 validation check
  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);

  const periodOptions = [
    { label: '년 빈도', value: 'year' },
    { label: '월 빈도', value: 'month' },
  ];

  const hobbyCheckData = [
    { label: '스쿠버다이빙', value: 'scubadiving' },
    { label: '행글라이딩, 패러글라이딩', value: 'paragliding' },
    { label: '스카이다이빙', value: 'skydiving' },
    { label: '수상스키', value: 'waterskiing' },
    { label: '자동차 경주, 오토바이 경주', value: 'motorracing' },
    { label: '번지점프', value: 'bungee' },
    { label: '빙벽, 암벽등반', value: 'rockclimbing' },
    { label: '제트스키', value: 'jetski' },
    { label: '래프팅', value: 'rafting' },
  ];

  useEffect(() => {
    checkButtonVisible(category3);
  }, [category3]);

  const checkButtonVisible = changeData => {
    const hobbyInfo = changeData.q01 || {};
    const { checkYn, period, frequency, frequency2 } = hobbyInfo;

    // 하단 다음 버튼 visible 처리
    let isValid = false;

    // '예'/'아니오' 둘 다 선택하지 않은 경우
    if (checkYn === '') {
      isValid = false;
    }

    // '예'를 선택한 경우
    else if (checkYn === 'Y') {
      const nonHobbyKeys = [
        'checkYn',
        'period',
        'frequency',
        'frequency2',
        'certification',
      ];
      const hobbyKeys = Object.keys(hobbyInfo).filter(
        key => !nonHobbyKeys.includes(key),
      );
      const isHobbySelected = hobbyKeys.some(
        hobbyKey => hobbyInfo[hobbyKey] === 'Y',
      );

      // 연빈도 선택 시 연빈도
      // 월빈도 선택 시 월빈도
      // 둘 중 하나 채워져 있는지 확인
      const isRequiredFilled =
        !isEmptyString(period) &&
        ((period === 'year' && !isEmptyString(frequency)) ||
          (period === 'month' && !isEmptyString(frequency2)));
      isValid = isHobbySelected && isRequiredFilled;
    }

    // '아니오'를 선택한 경우
    else if (checkYn === 'N') isValid = true; // 아니오를 선택한 경우 활성화 처리

    setIsDisabled(!isValid);
  };

  const validationCheckBox = checkData => {
    let checkYn = false;

    if (checkData.q01.checkYn === 'Y') {
      // 예 항목에 체크하였으나 체크박스 미체크 항목 추출
      for (const fieldName of Object.keys(checkData.q01)) {
        if (
          fieldName !== 'checkYn' &&
          fieldName !== 'period' &&
          fieldName !== 'frequency' &&
          fieldName !== 'frequency2' &&
          fieldName !== 'certification' &&
          checkData.q01[fieldName] === 'Y'
        ) {
          checkYn = true;
        }
      }

      if (!checkYn) {
        setErrorCheckSubData(true);
      } else {
        setErrorCheckSubData(false);
      }
    } else {
      setErrorCheckSubData(false);
    }
  };

  // 예, 아니오 버튼
  const handleButtonYnClick = value => {
    if (value === 'N') {
      // 아니오 버튼 선택 시 하위 요소 모두 해제
      for (const key of Object.keys(category3.q01)) {
        if (
          key === 'period' ||
          key === 'frequency' ||
          key === 'frequency2' ||
          key === 'certification'
        ) {
          category3.q01[key] = '';
        } else {
          category3.q01[key] = 'N';
        }
      }
    }
    validationCheckBox(category3);

    const changeData = {
      ...category3,
      q01: {
        ...category3.q01,
        checkYn: value,
      },
    };
    onChange({
      category3: changeData,
    });

    checkButtonVisible(changeData);
  };

  // 체크박스
  const handleCheckYnClick = (type, fieldName, value) => {
    const changeData = {
      ...category3,
      q01: {
        ...category3.q01,
        [fieldName]: value === true ? 'Y' : 'N',
        checkYn: value === true ? 'Y' : category3.q01.checkYn,
      },
    };
    onChange({ category3: changeData });

    validationCheckBox(changeData);
    checkButtonVisible(changeData);
  };

  // 년/월 빈도 선택
  const handleSelectPeriod = period => {
    const changeData = {
      ...category3,
      q01: {
        ...category3.q01,
        period,
      },
    };
    // 다른 선택지 초기화
    if (period === 'year') changeData.q01.frequency = '';
    else if (period === 'month') changeData.q01.frequency2 = '';

    onChange({ category3: changeData });

    validationCheckBox(changeData);
    checkButtonVisible(changeData);
  };

  const handleInputFrequency = (key, value) => {
    const changeData = {
      ...category3,
      q01: {
        ...category3.q01,
        [key]: value,
      },
    };
    onChange({ category3: changeData });

    validationCheckBox(changeData);
    checkButtonVisible(changeData);
  };

  // 자격증 정보 입력
  const handleInputOnChange = value => {
    const changeData = {
      ...category3,
      q01: {
        ...category3.q01,
        certification: value,
      },
    };
    onChange({ category3: changeData });

    validationCheckBox(changeData);
    checkButtonVisible(changeData);
  };

  const handleOnClick = () => {
    // 하단 다음 버튼
    if (isDisabled) {
      setShowErrorCheckMsg(true);
      validationCheckBox(category3);
    } else {
      onNext();
    }
  };

  return (
    <React.Fragment>
      <div className="infor-list">
        <SatQuestionArea
          title={() => (
            <p>
              1. 최근 1년 이내에 다음과 같은 취미를 자주 반복적으로 하고 있거나
              관련 자격증을 가지고 있으신가요? (있다면 세부항목을 선택해주세요.)
            </p>
          )}
          selectValue={category3.q01.checkYn}
          options={[
            { label: '예', value: 'Y' },
            { label: '아니요', value: 'N' },
          ]}
          useType={'btn'}
          name={'category3_q1'}
          onClick={value => handleButtonYnClick(value)}
          error={
            showErrorCheckMsg && category3.q01.checkYn === ''
              ? '취미 활동을 선택해 주세요.'
              : errorCheckSubData && '취미를 선택해주세요.'
          }
        />
        <div className="check-box">
          {hobbyCheckData.map((option, index) => {
            return (
              <React.Fragment key={`hobbyCheckData_${index}`}>
                <SatCheckBox
                  value={[category3.q01[option.value] === 'Y' ? true : false]}
                  options={[{ label: option.label, value: option.value }]}
                  onChange={value =>
                    handleCheckYnClick('q03', option.value, value)
                  }
                />
              </React.Fragment>
            );
          })}
        </div>
      </div>
      {category3.q01.checkYn === 'Y' && (
        <>
          <div className="infor-list">
            <SatQuestionArea
              title={() => <p>2. 위 취미의 빈도 회차를 선택해주세요.</p>}
              error={
                showErrorCheckMsg &&
                (category3.q01.frequency === '' ||
                  category3.q01.frequency2 === '') &&
                '빈도를 선택해 주세요.'
              }
            />

            <div className="box two">
              <div className="flex" style={{ gap: '1.2rem' }}>
                {periodOptions.map(option => (
                  <SatCheckBox
                    key={option.value}
                    value={[category3.q01.period === option.value]}
                    options={[option]}
                    onChange={() => handleSelectPeriod(option.value)}
                  />
                ))}
              </div>

              <div className="flex" style={{ gap: '1.2rem' }}>
                {category3.q01.period === 'year' && (
                  <SatInput
                    type="number"
                    title="년빈도"
                    placeholder="년빈도 입력"
                    customStyleClass="w-200"
                    outerSuffix={() => (
                      <label className="txt margin-vertical-auto">회</label>
                    )}
                    value={category3.q01.frequency}
                    onChange={value => handleInputFrequency('frequency', value)}
                  />
                )}

                {category3.q01.period === 'month' && (
                  <SatInput
                    type="number"
                    title="월빈도"
                    placeholder="월빈도 입력"
                    customStyleClass="w-200"
                    outerSuffix={() => (
                      <label className="txt margin-vertical-auto">회</label>
                    )}
                    value={category3.q01.frequency2}
                    onChange={value =>
                      handleInputFrequency('frequency2', value)
                    }
                  />
                )}
              </div>
            </div>
          </div>
          <div className="infor-list">
            <SatQuestionArea
              title={() => <p>3. 취미와 관련 자격증을 모두 기입해주세요.</p>}
            />
            <div className="check-box mgb-20">
              <SatInput
                value={category3.q01.certification || ''}
                type="text"
                placeholder="입력"
                maxLength={23}
                onChange={value => handleInputOnChange(value)}
              />
              <p className="text-info2 ico-type mgt-18">
                자격증은 최대 23자까지 입력가능해요. 여러개일 경우 쉼표로
                구분해주세요.
              </p>
            </div>
          </div>
        </>
      )}

      <div className="infor-list">
        <div className="btn-area">
          <div className="box-btns-center">
            <SatButton
              styleClass={`btn-s blue btn-wide ${isDisabled ? 'disabled' : ''}`}
              label="다음"
              onClick={handleOnClick}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default HobbyInfo;
